import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        localStorage.getItem('zlUsr')
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/auth/zl-admin/login', state: { from: props.location } }} />
    )} />
)